/* CelestialKinThreads - birth detail fields
   Pure JavaScript. Loaded as a theme asset so nothing has to survive JSON
   escaping, and so this file can be edited without rewriting product.json.

   Emitted line-item properties are BACKWARD COMPATIBLE. "Date of Birth",
   "Time of Birth" and "Place of Birth" keep the exact names and formats the
   Railway app already parses. Underscore-prefixed properties are additions:
   Shopify hides them from the customer and the order display, but they are
   returned by the Admin API, so app.py can migrate to the unambiguous ISO
   values whenever it is ready. Nothing breaks in the meantime.

   NOT SOLVED HERE: the UTC offset in force at the birth place on the birth
   date. That cannot be resolved in the browser - the visitor's own timezone is
   irrelevant and using it would be worse than having nothing. _Birth Country
   Code plus _Birth City are emitted so the server can resolve it properly. */
(function () {
  if (window.__cktFieldsV2) return;
  window.__cktFieldsV2 = true;
  /* The previous build was an inline script inside the custom_liquid setting in
     templates/product.json. It is still there, and it self-disables when this
     flag is already set. Claiming the flag here retires it without having to
     rewrite a 20KB auto-generated JSON file by hand. start() also removes a v1
     field box if one was somehow planted first, so load order does not matter. */
  window.__cktFieldsLoaded = true;

  var COUNTRY_DATA = "AF~Afghanistan|AX~Aland Islands|AL~Albania|DZ~Algeria|AS~American Samoa|AD~Andorra|AO~Angola|AI~Anguilla|AQ~Antarctica|AG~Antigua and Barbuda|AR~Argentina|AM~Armenia|AW~Aruba|AU~Australia|AT~Austria|AZ~Azerbaijan|BS~Bahamas|BH~Bahrain|BD~Bangladesh|BB~Barbados|BY~Belarus|BE~Belgium|BZ~Belize|BJ~Benin|BM~Bermuda|BT~Bhutan|BO~Bolivia|BA~Bosnia and Herzegovina|BW~Botswana|BV~Bouvet Island|BR~Brazil|IO~British Indian Ocean Territory|VG~British Virgin Islands|BN~Brunei|BG~Bulgaria|BF~Burkina Faso|BI~Burundi|KH~Cambodia|CM~Cameroon|CA~Canada|CV~Cape Verde|BQ~Caribbean Netherlands|KY~Cayman Islands|CF~Central African Republic|TD~Chad|CL~Chile|CN~China|CX~Christmas Island|CC~Cocos (Keeling) Islands|CO~Colombia|KM~Comoros|CG~Congo (Brazzaville)|CD~Congo (Kinshasa)|CK~Cook Islands|CR~Costa Rica|CI~Cote d'Ivoire|HR~Croatia|CU~Cuba|CW~Curacao|CY~Cyprus|CZ~Czechia|DK~Denmark|DJ~Djibouti|DM~Dominica|DO~Dominican Republic|EC~Ecuador|EG~Egypt|SV~El Salvador|GQ~Equatorial Guinea|ER~Eritrea|EE~Estonia|SZ~Eswatini|ET~Ethiopia|FK~Falkland Islands|FO~Faroe Islands|FJ~Fiji|FI~Finland|FR~France|GF~French Guiana|PF~French Polynesia|TF~French Southern Territories|GA~Gabon|GM~Gambia|GE~Georgia|DE~Germany|GH~Ghana|GI~Gibraltar|GR~Greece|GL~Greenland|GD~Grenada|GP~Guadeloupe|GU~Guam|GT~Guatemala|GG~Guernsey|GN~Guinea|GW~Guinea-Bissau|GY~Guyana|HT~Haiti|HM~Heard & McDonald Islands|HN~Honduras|HK~Hong Kong|HU~Hungary|IS~Iceland|IN~India|ID~Indonesia|IR~Iran|IQ~Iraq|IE~Ireland|IM~Isle of Man|IL~Israel|IT~Italy|JM~Jamaica|JP~Japan|JE~Jersey|JO~Jordan|KZ~Kazakhstan|KE~Kenya|KI~Kiribati|KW~Kuwait|KG~Kyrgyzstan|LA~Laos|LV~Latvia|LB~Lebanon|LS~Lesotho|LR~Liberia|LY~Libya|LI~Liechtenstein|LT~Lithuania|LU~Luxembourg|MO~Macao|MG~Madagascar|MW~Malawi|MY~Malaysia|MV~Maldives|ML~Mali|MT~Malta|MH~Marshall Islands|MQ~Martinique|MR~Mauritania|MU~Mauritius|YT~Mayotte|MX~Mexico|FM~Micronesia|MD~Moldova|MC~Monaco|MN~Mongolia|ME~Montenegro|MS~Montserrat|MA~Morocco|MZ~Mozambique|MM~Myanmar|NA~Namibia|NR~Nauru|NP~Nepal|NL~Netherlands|NC~New Caledonia|NZ~New Zealand|NI~Nicaragua|NE~Niger|NG~Nigeria|NU~Niue|NF~Norfolk Island|KP~North Korea|MK~North Macedonia|MP~Northern Mariana Islands|NO~Norway|OM~Oman|PK~Pakistan|PW~Palau|PS~Palestine|PA~Panama|PG~Papua New Guinea|PY~Paraguay|PE~Peru|PH~Philippines|PN~Pitcairn|PL~Poland|PT~Portugal|PR~Puerto Rico|QA~Qatar|RE~Reunion|RO~Romania|RU~Russia|RW~Rwanda|BL~Saint Barthelemy|SH~Saint Helena|KN~Saint Kitts and Nevis|LC~Saint Lucia|MF~Saint Martin|PM~Saint Pierre and Miquelon|VC~Saint Vincent and the Grenadines|WS~Samoa|SM~San Marino|ST~Sao Tome and Principe|SA~Saudi Arabia|SN~Senegal|RS~Serbia|SC~Seychelles|SL~Sierra Leone|SG~Singapore|SX~Sint Maarten|SK~Slovakia|SI~Slovenia|SB~Solomon Islands|SO~Somalia|ZA~South Africa|GS~South Georgia|KR~South Korea|SS~South Sudan|ES~Spain|LK~Sri Lanka|SD~Sudan|SR~Suriname|SJ~Svalbard and Jan Mayen|SE~Sweden|CH~Switzerland|SY~Syria|TW~Taiwan|TJ~Tajikistan|TZ~Tanzania|TH~Thailand|TL~Timor-Leste|TG~Togo|TK~Tokelau|TO~Tonga|TT~Trinidad and Tobago|TN~Tunisia|TR~Turkiye|TM~Turkmenistan|TC~Turks and Caicos Islands|TV~Tuvalu|UM~US Minor Outlying Islands|VI~US Virgin Islands|UG~Uganda|UA~Ukraine|AE~United Arab Emirates|GB~United Kingdom|US~United States|UY~Uruguay|UZ~Uzbekistan|VU~Vanuatu|VA~Vatican City|VE~Venezuela|VN~Vietnam|WF~Wallis and Futuna|EH~Western Sahara|YE~Yemen|ZM~Zambia|ZW~Zimbabwe";
  var PINNED = ['US', 'GB', 'CA', 'AU', 'IN'];

  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
                'August', 'September', 'October', 'November', 'December'];

  var MIN_YEAR = 1900;
  var MAX_YEAR = new Date().getFullYear();

  /* Every hidden-field sync function, so they can all be re-run immediately
     before the form is submitted. A control can hold a value that never fired
     change or input - browser back/forward restore, autofill, or a theme
     re-rendering the section will all do it. The hidden field would then
     submit EMPTY while the customer sees their answer on screen, and the order
     arrives with the property name present and no value in it. Observed live
     on order #7045716508947. */
  var SYNCS = [];

  var CSS =
    '.ckt-fields{margin:1.25rem 0;padding:1.1rem;border:1px solid rgba(0,0,0,.15);border-radius:.5rem}' +
    '.ckt-fields fieldset{border:0;padding:0;margin:0 0 1.1rem}' +
    '.ckt-fields fieldset+fieldset{border-top:1px solid rgba(0,0,0,.1);padding-top:1rem}' +
    '.ckt-fields legend{font-weight:600;font-size:1.02rem;padding:0}' +
    '.ckt-f{margin-bottom:.85rem}' +
    '.ckt-f label{display:block;margin-bottom:.3rem;font-size:.95rem}' +
    '.ckt-f input[type=text],.ckt-f input[type=time],.ckt-f select{' +
      'width:100%;padding:.6rem .7rem;font-size:1rem;border:1px solid rgba(0,0,0,.3);' +
      'border-radius:.3rem;background:#fff;color:#000}' +
    '.ckt-row{display:flex;gap:.5rem}' +
    '.ckt-row>div{flex:1 1 0;min-width:0}' +
    '.ckt-row>div.ckt-wide{flex:1.6 1 0}' +
    '.ckt-sub{display:block;font-size:.8rem;opacity:.7;margin-bottom:.25rem}' +
    '.ckt-hint{font-size:.85rem;opacity:.72;margin-top:.25rem}' +
    '.ckt-check{display:flex;align-items:flex-start;gap:.5rem;margin-top:.5rem}' +
    '.ckt-check input{margin-top:.25rem}' +
    '.ckt-req{color:#b03030}' +
    '.ckt-place-title{display:block;margin-bottom:.55rem;font-size:.95rem;font-weight:600}' +
    '.ckt-place .ckt-f{margin-bottom:.7rem}' +
    '.ckt-place .ckt-f:last-of-type{margin-bottom:0}' +
    '@media (max-width:480px){.ckt-row{flex-wrap:wrap}.ckt-row>div{flex:1 1 30%}}';

  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    for (var k in attrs) {
      if (k === 'text') n.textContent = attrs[k];
      else if (k === 'html') n.innerHTML = attrs[k];
      else n.setAttribute(k, attrs[k]);
    }
    (kids || []).forEach(function (c) { n.appendChild(c); });
    return n;
  }

  function opt(value, label) {
    var o = document.createElement('option');
    o.value = value;
    o.textContent = label;
    return o;
  }

  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  /* Days in month m (1-12) of year y. JS Date handles the Gregorian leap rule
     correctly, including the century exceptions: 1900 gives 28, 2000 gives 29. */
  function daysInMonth(y, m) { return new Date(y, m, 0).getDate(); }

  function parseCountries() {
    var out = [], seen = {};
    COUNTRY_DATA.split('|').forEach(function (row) {
      var i = row.indexOf('~');
      if (i > 0) { var c = row.slice(0, i); seen[c] = row.slice(i + 1); out.push([c, row.slice(i + 1)]); }
    });
    return { list: out, byCode: seen };
  }
  var COUNTRIES = parseCountries();

  /* ---------------------------------------------------------------- fields */

  function textField(id, label, prop, required, placeholder, hint) {
    var wrap = el('div', {'class': 'ckt-f'});
    wrap.appendChild(el('label', {'for': id, html: label + (required ? ' <span class="ckt-req">*</span>' : '')}));
    var i = el('input', {type: 'text', id: id, name: 'properties[' + prop + ']'});
    if (required) i.setAttribute('required', 'required');
    if (placeholder) i.setAttribute('placeholder', placeholder);
    wrap.appendChild(i);
    if (hint) wrap.appendChild(el('div', {'class': 'ckt-hint', text: hint}));
    return wrap;
  }

  /* Month / day / year as three separate selects.

     The browser's native calendar used to enforce the month lengths for free.
     Selects do not, so the day list is rebuilt from the chosen month and year
     every time either changes: February shows 28 days in 1999 and 29 in 2000,
     and April never shows a 31st. A day that becomes invalid is cleared rather
     than silently clamped, so the customer re-picks it deliberately instead of
     being given a date they did not choose.

     Until a year is picked, February offers 29 - the year may yet be a leap
     year. Picking a non-leap year afterwards clears it. */
  function dateField(idBase, label, prop, isoProp) {
    var wrap = el('div', {'class': 'ckt-f'});
    wrap.appendChild(el('label', {html: label + ' <span class="ckt-req">*</span>'}));

    var mSel = el('select', {id: idBase + '-m', required: 'required', 'aria-label': 'Birth month'});
    mSel.appendChild(opt('', 'Month'));
    MONTHS.forEach(function (name, i) { mSel.appendChild(opt(pad2(i + 1), name)); });

    var dSel = el('select', {id: idBase + '-d', required: 'required', 'aria-label': 'Birth day'});

    var ySel = el('select', {id: idBase + '-y', required: 'required', 'aria-label': 'Birth year'});
    ySel.appendChild(opt('', 'Year'));
    for (var y = MAX_YEAR; y >= MIN_YEAR; y--) ySel.appendChild(opt(String(y), String(y)));

    function rebuildDays() {
      var m = parseInt(mSel.value, 10);
      var yr = parseInt(ySel.value, 10);
      var max = 31;
      if (m) max = isNaN(yr) ? daysInMonth(2000, m) : daysInMonth(yr, m); // 2000 is a leap year
      var keep = dSel.value;
      while (dSel.firstChild) dSel.removeChild(dSel.firstChild);
      dSel.appendChild(opt('', 'Day'));
      for (var d = 1; d <= max; d++) dSel.appendChild(opt(pad2(d), String(d)));
      dSel.value = (keep && parseInt(keep, 10) <= max) ? keep : '';
    }

    var out = el('input', {type: 'hidden', name: 'properties[' + prop + ']'});
    var iso = el('input', {type: 'hidden', name: 'properties[' + isoProp + ']'});

    function sync() {
      var m = mSel.value, d = dSel.value, y = ySel.value;
      if (m && d && y && parseInt(d, 10) <= daysInMonth(parseInt(y, 10), parseInt(m, 10))) {
        out.value = m + '/' + d + '/' + y;   // MM/DD/YYYY - unchanged, app.py parses this
        iso.value = y + '-' + m + '-' + d;   // YYYY-MM-DD - unambiguous, for the pipeline
      } else {
        out.value = ''; iso.value = '';
      }
    }

    function onChange() { rebuildDays(); sync(); }
    mSel.addEventListener('change', onChange);
    ySel.addEventListener('change', onChange);
    dSel.addEventListener('change', sync);

    rebuildDays();
    sync();                      // the browser may have restored values already
    SYNCS.push(function () { rebuildDays(); sync(); });

    var row = el('div', {'class': 'ckt-row'});
    var cm = el('div', {'class': 'ckt-wide'}); cm.appendChild(mSel);
    var cd = el('div'); cd.appendChild(dSel);
    var cy = el('div'); cy.appendChild(ySel);
    row.appendChild(cm); row.appendChild(cd); row.appendChild(cy);
    wrap.appendChild(row);
    wrap.appendChild(out); wrap.appendChild(iso);
    return wrap;
  }

  /* Time stays a native <input type="time">: it shows AM/PM to Americans and a
     24-hour clock to everyone else, it allows any minute, and it submits a
     clean HH:MM. Dropping to 5-minute increments would blur the Rising sign
     near a cusp, which the FAQ promises not to do. */
  function timeField(id, label, prop, unkProp, h24Prop, hint) {
    var wrap = el('div', {'class': 'ckt-f'});
    wrap.appendChild(el('label', {'for': id, text: label}));
    var vis = el('input', {type: 'time', id: id});
    var out = el('input', {type: 'hidden', name: 'properties[' + prop + ']'});
    var h24 = el('input', {type: 'hidden', name: 'properties[' + h24Prop + ']'});
    var chk = el('input', {type: 'checkbox', id: id + '-unk',
                           name: 'properties[' + unkProp + ']', value: 'Yes'});
    function sync() {
      if (chk.checked || !vis.value) { out.value = ''; h24.value = ''; return; }
      var p = vis.value.split(':'), h = parseInt(p[0], 10), m = p[1] || '00';
      if (isNaN(h)) { out.value = ''; h24.value = ''; return; }
      var ap = h >= 12 ? 'PM' : 'AM', h12 = h % 12; if (h12 === 0) h12 = 12;
      out.value = h12 + ':' + m + ' ' + ap;   // unchanged
      h24.value = pad2(h) + ':' + m;          // unambiguous
    }
    vis.addEventListener('change', sync); vis.addEventListener('input', sync);
    chk.addEventListener('change', function () {
      if (chk.checked) { vis.value = ''; vis.disabled = true; } else { vis.disabled = false; }
      sync();
    });
    vis.addEventListener('blur', sync);
    sync();
    SYNCS.push(sync);
    var row = el('div', {'class': 'ckt-check'});
    row.appendChild(chk);
    row.appendChild(el('label', {'for': id + '-unk', text: "I don't know the birth time"}));
    wrap.appendChild(vis); wrap.appendChild(out); wrap.appendChild(h24); wrap.appendChild(row);
    if (hint) wrap.appendChild(el('div', {'class': 'ckt-hint', text: hint}));
    return wrap;
  }

  /* A US birth prints as "Asheville, North Carolina", not "Asheville, NC,
     United States". The country is a no-op to an American reader and the
     abbreviation is postal shorthand, so on a framed portrait both read like a
     shipping label rather than a line someone chose.

     The country is NOT dropped blindly. "Place of Birth" is also the string
     Nominatim geocodes, and a bare "Birmingham" resolves to England — wrong
     coordinates, wrong timezone, wrong chart, printed beautifully. So the
     country only comes off when a state is present to disambiguate it, and a
     US birth with the optional region left blank keeps "United States".

     Everywhere else keeps its country, because the country is doing real work
     in nearly every one of those. What it no longer keeps is the same place
     said twice — see composePlace below. */
  var US_STATES = {
    AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas',
    CA: 'California', CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware',
    DC: 'District of Columbia', FL: 'Florida', GA: 'Georgia', HI: 'Hawaii',
    ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', IA: 'Iowa', KS: 'Kansas',
    KY: 'Kentucky', LA: 'Louisiana', ME: 'Maine', MD: 'Maryland',
    MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota', MS: 'Mississippi',
    MO: 'Missouri', MT: 'Montana', NE: 'Nebraska', NV: 'Nevada',
    NH: 'New Hampshire', NJ: 'New Jersey', NM: 'New Mexico', NY: 'New York',
    NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio', OK: 'Oklahoma',
    OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island',
    SC: 'South Carolina', SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas',
    UT: 'Utah', VT: 'Vermont', VA: 'Virginia', WA: 'Washington',
    WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming'
  };

  /* Accepts "NC", "nc", "N.C." or "north carolina" and returns "North
     Carolina". Anything unrecognised is handed back untouched rather than
     guessed at — a region this does not know is still better in the string
     than removed from it. */
  var US_STATE_LOOKUP = (function () {
    var m = {};
    for (var abbr in US_STATES) {
      m[abbr] = US_STATES[abbr];
      m[US_STATES[abbr].toUpperCase()] = US_STATES[abbr];
    }
    return m;
  })();

  function expandUsState(region) {
    var key = region.replace(/\./g, '').replace(/\s+/g, ' ').trim().toUpperCase();
    return US_STATE_LOOKUP[key] || null;
  }

  /* ------------------------------------------------- de-duplicating a place

     The region box is free text, and customers put whatever they like in it.
     Order #1157 arrived with city "Santiago de Cuba", region "Santiago de
     Cuba/ Cuba" and country "Cuba", and City + Region + Country printed

         Santiago de Cuba, Santiago de Cuba/ Cuba, Cuba

     on a framed portrait that had already reached the printer. The chart was
     correct — only the label was wrong — but it is the line the customer
     reads first.

     So before composing, the region is split on its separators and any part
     that is only the COUNTRY said again is dropped, along with exact repeats.
     Nothing else about what they typed is touched.

     A region identical to the city is also dropped. Berlin really is its own
     state and Santiago de Cuba really is its own province, so the doubled
     name is TRUE - but on a framed portrait it reads as a form glitch, and a
     keepsake cannot afford that. The part is still stored on the order and
     still available to the geocoder; it just does not hang on a wall.

     A region that is a DIFFERENT word - Bavaria, Tuscany, Ontario - is kept.
     It does real work for an American reader. Only the US drops its country,
     because "United States" is noise to the reader it prints for. */

  /* Only the variants people actually type into a region box. Deliberately
     short: guessing wrong here deletes a real region from a real portrait. */
  var COUNTRY_ALIASES = {
    US: ['usa', 'u s a', 'united states of america', 'america'],
    GB: ['uk', 'u k', 'great britain', 'britain'],
    AE: ['uae', 'u a e'],
    KR: ['republic of korea'],
    KP: ["democratic people's republic of korea"],
    RU: ['russian federation'],
    CZ: ['czech republic'],
    TR: ['turkey'],
    NL: ['holland', 'the netherlands'],
    VA: ['vatican', 'holy see'],
    MM: ['burma'],
    CI: ['ivory coast'],
    CV: ['cabo verde'],
    SZ: ['swaziland'],
    MK: ['macedonia'],
    TL: ['east timor']
  };

  /* Lowercase, fold accents, drop punctuation, collapse whitespace. Used only
     for comparing — never for anything that gets printed, so folding "São"
     to "sao" here costs nothing and catches a customer who typed the city
     with accents and the region without. */
  function normLoose(s) {
    var v = String(s == null ? '' : s).toLowerCase();
    if (v.normalize) v = v.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return v.replace(/[‘’'`.]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function countryKeys(code, country) {
    var keys = {}, extra = COUNTRY_ALIASES[code] || [], i;
    if (code) keys[normLoose(code)] = 1;
    if (country) keys[normLoose(country)] = 1;
    for (i = 0; i < extra.length; i++) keys[normLoose(extra[i])] = 1;
    return keys;
  }

  /* dropCity is false for a US birth: "New York, New York" is idiomatic and
     has always printed that way, so the state is left alone there. */
  function cleanRegion(region, city, code, country, dropCity) {
    var kill = countryKeys(code, country);
    var cityKey = normLoose(city);
    var seen = {}, out = [];
    String(region == null ? '' : region).split(/[\/,;|]+/).forEach(function (part) {
      var p = part.replace(/\s+/g, ' ').trim();
      if (!p) return;
      var k = normLoose(p);
      if (!k || kill[k] || seen[k]) return;
      if (dropCity && k === cityKey) return;
      seen[k] = 1;
      out.push(p);
    });
    return out.join(', ');
  }

  /* A city typed as "Santiago de Cuba, Cuba" should not print the country
     twice either. Only a trailing country is removed, and never the whole
     value — "Cuba" as the city stays "Cuba". */
  function cleanCity(city, code, country) {
    var parts = String(city == null ? '' : city)
      .replace(/\s+/g, ' ').trim().split(/\s*,\s*/);
    var kill = countryKeys(code, country);
    while (parts.length > 1 && kill[normLoose(parts[parts.length - 1])]) parts.pop();
    return parts.join(', ');
  }

  /* The country comes off ONLY when the region resolves to a real state. A
     county, a typo, or anything else unrecognised keeps "United States" on the
     end, because at that point the string is carrying the geocoder and not the
     reader. */
  function composePlace(code, city, region, country) {
    var c = cleanCity(city, code, country);
    var r = cleanRegion(region, c, code, country, code !== 'US');
    if (code === 'US' && r) {
      var state = expandUsState(r);
      if (state) return c + ', ' + state;
    }
    return r ? (c + ', ' + r + ', ' + country) : (c + ', ' + country);
  }

  /* Country + city + optional region, instead of a US-shaped "City, State" box.
     "Place of Birth" is still emitted, as "City, Region, Country" — or
     "City, State" for a US birth, see composePlace above — which geocodes
     better than a bare city name and keeps app.py working unchanged.
     The parts are emitted separately as well so the server can resolve the
     birth timezone from a country code rather than guessing at a string. */
  function placeField(idBase, label, propBase) {
    var wrap = el('div', {'class': 'ckt-f ckt-place'});
    wrap.appendChild(el('div', {'class': 'ckt-place-title',
                                html: label + ' <span class="ckt-req">*</span>'}));

    var cSel = el('select', {id: idBase + '-country', required: 'required', 'aria-label': 'Country of birth'});
    cSel.appendChild(opt('', 'Country'));
    PINNED.forEach(function (code) {
      if (COUNTRIES.byCode[code]) cSel.appendChild(opt(code, COUNTRIES.byCode[code]));
    });
    var sep = opt('', '----------');
    sep.disabled = true;
    cSel.appendChild(sep);
    COUNTRIES.list.forEach(function (row) { cSel.appendChild(opt(row[0], row[1])); });

    var city = el('input', {type: 'text', id: idBase + '-city', required: 'required',
                            placeholder: 'City or town'});
    var region = el('input', {type: 'text', id: idBase + '-region',
                              placeholder: 'State or province'});

    var combined = el('input', {type: 'hidden', name: 'properties[' + propBase + ']'});
    var hCity = el('input', {type: 'hidden', name: 'properties[_' + propBase + ' City]'});
    var hRegion = el('input', {type: 'hidden', name: 'properties[_' + propBase + ' Region]'});
    var hCountry = el('input', {type: 'hidden', name: 'properties[_' + propBase + ' Country]'});
    var hCode = el('input', {type: 'hidden', name: 'properties[_' + propBase + ' Country Code]'});

    function sync() {
      var code = cSel.value;
      var country = code ? (COUNTRIES.byCode[code] || '') : '';
      var c = (city.value || '').trim();
      var r = (region.value || '').trim();
      hCity.value = c;
      hRegion.value = r;
      hCountry.value = country;
      hCode.value = code;
      if (c && country) {
        combined.value = composePlace(code, c, r, country);
      } else {
        combined.value = '';
      }
    }
    [cSel, city, region].forEach(function (n) {
      n.addEventListener('change', sync);
      n.addEventListener('input', sync);
      n.addEventListener('blur', sync);
    });
    sync();
    SYNCS.push(sync);

    /* One label above each box, one line of help below that same box, and
       nothing floating in between. The previous build had two helper lines
       belonging to no particular field - one of them sitting between the
       country dropdown and the two text boxes, so it read as an instruction
       about the dropdown - plus a placeholder offering three slash-separated
       words for one field. That placeholder is what invited a customer to
       type a province AND a country into the region box on order #1157. */
    function sub(labelText, control, hintText) {
      var f = el('div', {'class': 'ckt-f'});
      f.appendChild(el('label', {'for': control.id, text: labelText}));
      f.appendChild(control);
      f.appendChild(el('div', {'class': 'ckt-hint', text: hintText}));
      return f;
    }

    wrap.appendChild(sub('Country', cSel,
      'Sets the birth timezone, so the chart is read against the right clock.'));
    wrap.appendChild(sub('City or town', city,
      'The town itself, not the nearest big city.'));
    wrap.appendChild(sub('State or province', region,
      'Optional. Skip it if it has the same name as the town, or you are not sure.'));

    wrap.appendChild(combined);
    wrap.appendChild(hCity); wrap.appendChild(hRegion);
    wrap.appendChild(hCountry); wrap.appendChild(hCode);
    return wrap;
  }

  /* ----------------------------------------------------------------- build */

  var NOGUESS = "Leave it blank if you're not sure. We build the portrait from " +
                "what's certain rather than guessing — a guessed time produces a " +
                "wrong Rising sign.";

  function detectType() {
    var hay = (location.pathname + ' ' + (document.title || '') + ' ' +
               ((document.querySelector('h1') || {}).textContent || '')).toLowerCase();
    if (hay.indexOf('couple') > -1 || hay.indexOf('synastry') > -1 ||
        hay.indexOf('compatib') > -1) return 'couple';
    if (hay.indexOf('gift') > -1) return 'gift';
    return 'ind';
  }

  function build(type) {
    var box = el('div', {'class': 'ckt-fields', 'data-ckt-fields': '1', 'data-ckt-v2': '1'});
    box.appendChild(el('style', {text: CSS}));

    if (type === 'couple') {
      [1, 2].forEach(function (n) {
        var p = 'Person ' + n;
        var fs = el('fieldset');
        fs.appendChild(el('legend', {text: p}));
        fs.appendChild(textField('ckt-p' + n + '-name', 'Full name', p + ' Name', true));
        fs.appendChild(dateField('ckt-p' + n + '-dob', 'Date of birth',
                                 p + ' Date of Birth', '_' + p + ' Date of Birth ISO'));
        fs.appendChild(timeField('ckt-p' + n + '-tob', 'Time of birth',
                                 p + ' Time of Birth',
                                 p + ' Birth Time Unknown',
                                 '_' + p + ' Time of Birth 24h', NOGUESS));
        fs.appendChild(placeField('ckt-p' + n + '-pob', 'Place of birth', p + ' Place of Birth'));
        box.appendChild(fs);
      });
      box.appendChild(el('div', {'class': 'ckt-hint',
        text: 'Either person can have an unknown birth time — the portrait is still built correctly.'}));
    } else {
      var fs2 = el('fieldset');
      fs2.appendChild(el('legend', {text: type === 'gift' ? 'Their birth details' : 'Your birth details'}));
      fs2.appendChild(textField('ckt-name', 'Full name', 'Full Name', true,
                                'As it should appear on the portrait'));
      fs2.appendChild(dateField('ckt-dob', 'Date of birth', 'Date of Birth', '_Date of Birth ISO'));
      fs2.appendChild(timeField('ckt-tob', 'Time of birth', 'Time of Birth',
                                'Birth Time Unknown', '_Time of Birth 24h', NOGUESS));
      fs2.appendChild(placeField('ckt-pob', 'Place of birth', 'Place of Birth'));
      box.appendChild(fs2);

      if (type === 'gift') {
        var fs3 = el('fieldset');
        fs3.appendChild(el('legend', {text: 'From you'}));
        fs3.appendChild(textField('ckt-gifter', 'Your name, as it appears on the portrait',
                                  'Gift From', true, 'Mom, Dad, Aunt Shirley, Grandma Rose',
                                  "However you'd want them to read it."));
        box.appendChild(fs3);
      }
    }
    return box;
  }

  /* Shopify only submits properties[...] inputs that sit INSIDE the cart form,
     and every theme puts that form somewhere different. Find it at run time. */
  function plant(box) {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      if (!f.offsetParent && f.getClientRects().length === 0) continue;
      var anchor = f.querySelector('.product-form__buttons') || f.querySelector('[type="submit"]');
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(box, anchor);
      else f.appendChild(box);
      guard(f);
      return true;
    }
    return false;
  }

  function syncAll() { for (var i = 0; i < SYNCS.length; i++) { try { SYNCS[i](); } catch (e) {} } }

  function guard(form) {
    if (form.__cktGuarded) return;
    form.__cktGuarded = true;
    form.addEventListener('submit', syncAll, true);
    // AJAX carts serialise on click and never fire submit — catch that too,
    // in the capture phase so we run before the theme reads the form.
    form.addEventListener('click', function (ev) {
      var t = ev.target;
      if (t && t.closest && t.closest('[type="submit"], [name="add"], .product-form__submit')) syncAll();
    }, true);
    form.addEventListener('change', syncAll, true);
  }

  function start() {
    if (document.querySelector('[data-ckt-v2]')) return;
    // retire a v1 box if the old inline script won the race
    var v1 = document.querySelector('[data-ckt-fields]:not([data-ckt-v2])');
    if (v1 && v1.parentNode) v1.parentNode.removeChild(v1);
    var box = build(detectType());
    if (plant(box)) return;
    var tries = 0;
    var iv = setInterval(function () {
      if (plant(box) || ++tries > 40) {
        clearInterval(iv);
        if (tries > 40) console.error('[CKT] No add-to-cart form found — birth details will not be attached.');
      }
    }, 250);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();